import ReportDom from "../../../../../components/common/ReportDom";
import SalesOrderVoucherBody from "./SalesOrderVoucherBody";

export default function SalesOrderPrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <SalesOrderVoucherBody sale_o_id={id} printMode />}
    />
  );
}
